// Get Similar Creators
export const GET_SIMILAR_CREATORS_REQUEST = 'GET_SIMILAR_CREATORS_REQUEST';
export const GET_SIMILAR_CREATORS_DONE = 'GET_SIMILAR_CREATORS_DONE';
export const GET_SIMILAR_CREATORS_FAILED = 'GET_SIMILAR_CREATORS_FAILED';

export const GET_SIMILAR_CREATORS_RESET = 'GET_SIMILAR_CREATORS_RESET';
